import { createFileRoute } from '@tanstack/react-router'
import { Server } from 'lucide-react'
import { StorageScreen } from '@/screens/connect/SCR-042-storage'

export const Route = createFileRoute('/_app/connect/storage')({
  staticData: { screen: { id: 'SCR-042', title: 'Storage backends', group: 'Connect', perm: 'deployment.manage', order: 11, description: 'Where memory records, the search index, payloads, queues and keys live, with live health. Read-only.', icon: Server } },
  component: StorageScreen,
})
